// 全局控制一些东西，例如主题样式，暗黑模式
// 语言国际化控制（目前逻辑仅做了中英文）
const appStore = {
  namespaced: true,
  state: () => ({
    /* 网络请求拦截的loading */
    isLoadingShow: false,
    layout: {
      // /* 全局 */
      // // 是否暗黑模式
      // isDark: false,
      //
      // /* 一些通用颜色 */
      // // 顶栏文字色
      // barTabColor: ['#000000', '#CFD3DC'],
      // // 激活项背景色
      // barTabActiveBackground: ['#ffffff', '#1d1e1f'],
      // // 激活项文字色
      // barTabActiveColor: ['#000000', '#409EFF'],
      // // 顶栏背景色
      // barBackground: ['#ffffff', '#1d1e1f'],
      // // 悬停时背景色
      // barHoverBackground: ['#f5f5f5', '#18222c']
    },
    lang: {
      // 默认语言，可选值<zh-cn|en>
      defaultLang: 'zh-cn',
      // 当在默认语言包找不到翻译时，继续在 fallbackLang 语言包内查找翻译
      fallbackLang: 'zh-cn',
      // 支持的语言列表
      langArray: [
        {name: 'zh-cn', value: '中文简体'},
        {name: 'en', value: 'English'}
      ]
    }
  }),
  getters: {
    isLoadingShow (state) {
      return state.isLoadingShow
    },
    getLayoutConfig (state) {
      return state.layout
    },
    // 获取是否暗夜模式
    getDarkStyle (state) {
      return state.layout.isDark
    },
    // 获取颜色
    getColorVal: (state) => (name) => {
      const colors = state.layout[name]
      if (state.layout.isDark) {
        return colors[1]
      } else {
        return colors[0]
      }
    },
    getLangConfig: (state) => (type) => {
      if (type === 'cb') {
        return state.lang.fallbackLang
      }
      if (type === 'array') {
        return state.lang.langArray
      }
      return state.lang.defaultLang
    }
  },
  mutations: {
    setLang (state, data) {
      state.lang.defaultLang = data
    },
    setDarkTheme (state, data) {
      state.layout.isDark = data
    },
    // 展示loading的方法
    showLoading(state) {
      state.isLoadingShow = true
    },
    // 隐藏loading的方法
    hideLoading(state) {
      state.isLoadingShow = false
    }
  },
  actions: {
    setLang ({commit}, data) {
      commit('setLang', data)
    },
    setDarkTheme ({commit}, data) {
      commit('setDarkTheme', data)
    },
    showLoading({commit}, data) {
      if (data === 1) {
        commit('showLoading')
      } else {
        commit('hideLoading')
      }
    }
  }
}

export default appStore
